import styled from 'styled-components';
import { tokens } from '@plataforma/components';
import { colors, fonts, grid } from '_/styles';
import { Button as ButtonComponent } from 'junto-ui';

export const Title = styled.h1`
  color: ${colors.textMain};
  font-weight: ${tokens.font.weight.semibold};
  font-size: ${fonts.size.large};
  margin-bottom: ${grid.small};
`;

export const EndorsementList = styled.div`
  margin-bottom: ${grid.large};
`;

export const NoEndorsementText = styled.p`
  margin-bottom: ${grid.medium};
  font-size: ${fonts.size.default};
  color: ${colors.textOption};
`;

export const Button = styled(ButtonComponent)`
  min-width: 120px;
  font-family: ${tokens.font.family.metropolis};
  font-weight: ${tokens.font.weight.semibold};
  ${({ full }) => full && 'width:100%;'}
`;
